<template>
  <div v-if="list && list.length" class="products sides-padding">
    <div class="container">
      <h2 class="products__title">{{ title }}</h2>
      <div class="products__list">
        <ProductCardComponent v-for="(item, i) in list" :key="i" :data="item" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductCardComponent from "components/product/ProductCardComponent.vue";

export default {
  name: "ProductsComponent",
  components: { ProductCardComponent },
  props: {
    title: String,
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="stylus">
.products {
  &__title {
    margin-bottom: 30px;
  }

  &__list {
    display grid
    grid-template-columns repeat(6, 1fr)
    grid-gap 30px
    +below(1200px) {
      grid-template-columns: repeat(auto-fit, 238px);
      grid-auto-columns: 238px;
      grid-auto-flow: column;
      overflow-x: auto;
      margin: 0 calc(-1 * var(--sides_padding));
      padding: 0 var(--sides_padding);
      grid-gap: 30px;
    }
    +below(560px) {
      grid-template-columns: repeat(auto-fit, 210px);
      grid-auto-columns: 210px;
    }
    +below(480px) {
      grid-template-columns: repeat(auto-fit, 180px);
      grid-auto-columns: 180px;
    }
    +below(420px) {
      grid-template-columns: repeat(auto-fit, 167px);
      grid-auto-columns: 167px;
    }
  }
}
</style>
